/* @flow */
import React from 'react';
// $FlowIgnore
import { MdAssignment } from 'react-icons/md';

export default function DocumentationIcon({
  style
}: Object): React.Element {
  return <MdAssignment style={style} />;
}
